import React from "react";

const WspolnotaRozliczenieSeryjneTHead = () => {

  return (
    <thead>
      <tr key={0}>
        <th>Mieszkaniec</th>
        <th>Lokal</th>
      </tr>
    </thead>
  )
}

export default WspolnotaRozliczenieSeryjneTHead;